export default __webpack_public_path__ + "static/media/glitch14.32605042.png";